import classNames from "classnames";
import AscFilesUploader from "../../../AscFilesUploader/AscFilesUploader";
import AscTextInput from "../../../AscInputFields/AscTextInput/AscTextInput";
import AscRichTextEditor from "../../../AscRichTextEditor/AscRichTextEditor";
import AscParagraph from "../../../AscTypography/AscParagraph/AscParagraph";

import styles from "./AscDigDeeper.module.scss";
import { useAscAddModuleContentForm } from "../useAscAddModuleContentForm";
import { AdminModuleContentForm } from "@ascendnow/shared";

export interface AscDigDeeperProps {
  className?: string;
}

function AscDigDeeper({ className }: AscDigDeeperProps) {
  const formik = useAscAddModuleContentForm();

  const handleFileUpload = (acceptedFiles: AdminModuleContentForm["file"]) => {
    const notTouched =
      acceptedFiles?.length === formik?.values?.file?.length &&
      acceptedFiles?.every(
        (file, index) =>
          file?.__moduleContentFile?.id ===
          formik?.values?.file?.[index]?.__moduleContentFile?.id
      );
    if (!notTouched) {
      formik.setFieldValue("file", acceptedFiles);
      formik.setFieldTouched("file", true);
    }
  };

  return (
    <div className={classNames(styles.ground, className)}>
      <div className={styles.form}>
        <label className={styles.fieldLabel} htmlFor="title">
          Title
        </label>
        <AscTextInput
          className={classNames(styles.inputField, {
            [styles.errorInput]: formik.errors.title && formik.touched.title,
          })}
          fullWidth={true}
          placeholder="Enter title"
          id="title"
          name="title"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.title}
        />
        {formik.errors.title && formik.touched.title && (
          <div className={styles.fieldError}>{formik.errors.title}</div>
        )}
      </div>

      <AscParagraph className={styles.title}>Description</AscParagraph>

      <div className={styles.textEditorGround}>
        <AscRichTextEditor
          editable={true}
          initialInferValue={formik.values.description}
          onJsonChange={(value) => {
            formik.setFieldTouched(
              "description",
              value !== formik.values.description
            );
            formik.setFieldValue("description", value);
          }}
          className={styles.richTextEditor}
          inputWrapperClassname={styles.richTextEditorInput}
        />
      </div>

      <AscParagraph className={styles.title}>Add files </AscParagraph>
      <AscFilesUploader
        name="file"
        multiple={true}
        initialValue={formik.values?.file}
        onChange={handleFileUpload}
      />
    </div>
  );
}

export default AscDigDeeper;
